import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

/**
 * 主布局组件
 * 采用与开发者平台一致的布局结构
 */
export const Layout = () => {
  const currentYear = new Date().getFullYear();
  const foundedYear = 2026;
  
  const copyrightYear = currentYear === foundedYear 
    ? foundedYear 
    : `${foundedYear}-${currentYear}`;

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      {/* 顶部 Header - 固定高度 */}
      <Header />
      
      {/* 主体内容区域 - 包含侧边栏和内容 */}
      <div className="flex flex-1 overflow-hidden">
        {/* 左侧侧边栏 - 固定宽度 */}
        <Sidebar />
        
        {/* 右侧主内容区域 - 可滚动 */}
        <main className="flex-1 overflow-auto bg-gray-50 p-6">
          <div className="max-w-7xl mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
      
      {/* 页脚 - 固定在底部 */}
      <footer className="bg-white border-t border-gray-200 py-4 px-6">
        <div className="text-center text-sm text-gray-500">
          ©{copyrightYear} 深圳轻智云创新物联科技有限公司 版权所有
          <span className="mx-3">|</span>
          <a 
            href="https://beian.miit.gov.cn/#/Integrated/index" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-blue-600 no-underline transition-colors"
          >
            粤ICP备2026011563号-2
          </a>
        </div>
      </footer>
    </div>
  );
};